import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { CodeNodeView } from "@/components/editor/nodeviews/CodeNodeView";

export const CodeBlockNode = Node.create({
  name: "codeBlockNode",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      code: { default: "" },
      language: { default: "plaintext" },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="code-block-node"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "code-block-node" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(CodeNodeView);
  },
});
